<template>
  <div>
    <a-drawer
      width="600"
      title="新建实验层"
      placement="right"
      :closable="false"
      v-model:visible="layerDrawerVisible"
      @close="closeCreateDrawer"
    >
      <a-form
        ref="createFormRef"
        :rules="createFormRules"
        :model="createForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="实验层名称" name="name">
          <a-input
            :maxlength="100"
            :disabled="createFormDisabled"
            v-model:value="createForm.name"
          />
        </a-form-item>
        <a-form-item label="分层主体" name="subject">
          <a-radio-group v-model:value="createForm.subject">
            <a-radio :value="1">Distinct Id</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="实验层类型" name="type">
          <a-radio-group v-model:value="createForm.type">
            <a-radio :value="1">粘性实验层</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="描述" name="description">
          <a-textarea :maxlength="200" v-model:value="createForm.description" />
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button style="margin-right: 8px" @click="closeCreateDrawer"
          >取消</a-button
        >
        <a-button type="primary" @click="saveCreateDrawer">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject } from 'vue'
import { post_abLayer_new_save } from '@/server/modules/21934'
import { message } from 'ant-design-vue'
export default defineComponent({
  setup() {
    const initData = inject('initState')
    const state = reactive({
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      },
      createFormRef: null,
      closeCreateDrawer: () => {
        state.createForm = {
          name: '',
          subject: 1,
          description: '',
          type: 1
        }
        state.createFormRef.resetFields()
        initData.layerDrawerVisible = false
      },
      saveCreateDrawer: () => {
        const { brandId, siteId, channelId, terminalId } = initData.baseInfo
        state.createFormRef.validate().then(async () => {
          const { success, retInfo } = await post_abLayer_new_save({
            ...{ brandId, siteId, channelId, terminalId },
            ...state.createForm
          })
          if (success) {
            initData.getLayorList(state.createForm.name)
            state.closeCreateDrawer()
          } else {
            message.error(retInfo)
          }
        })
      },
      createForm: {
        name: '',
        subject: 1,
        description: '',
        type: 1
      },
      createFormRules: {
        name: [
          { required: true, message: '请输入实验层名称', trigger: 'blur' },
          {
            validator: (rule, value) => {
              const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_\-'"‘’“”]+$/
              if (!regex.test(value)) {
                return Promise.reject(
                  new Error(
                    '支持输入中文、英文、数字、下划线、中划线、引号、双引号，不支持特殊字符'
                  )
                )
              } else {
                return Promise.resolve()
              }
            },
            trigger: 'blur'
          }
        ],
        subject: [
          {
            required: true,
            message: '请选择分层主体',
            trigger: 'change',
            type: 'number'
          }
        ]
      }
    })
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
})
</script>
<style>
.self-process .ant-progress-inner {
  height: 40px;
  border-radius: 0px !important;
}
.self-process .ant-progress-inner .ant-progress-bg {
  height: 40px !important;
  border-radius: 0px !important;
}
</style>
